<div class="root" skyTranslationGuard="skypro-code-editor">
  <textarea class="textarea" #codeRef data-test="редактор кода"></textarea>
</div>
